import { useEffect, useState } from "react";
import { WP_API_URL, DEFAULT_SETTINGS } from "@/data/siteContent";

const parseSettings = (html) => {
  const text = html
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "");
  const out = {};
  const doc = document.createElement("textarea");
  text.split("\n").forEach((line) => {
    const i = line.indexOf(":");
    if (i < 1) return;
    const key = line
      .slice(0, i)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    doc.innerHTML = line.slice(i + 1).trim();
    const value = doc.value;
    if (key && value) out[key] = value;
  });
  return out;
};

let cache = null;

export const useSiteContent = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    let cancelled = false;
    if (!cache) {
      cache = fetch(`${WP_API_URL}/pages?slug=site-content`)
        .then((r) => r.json())
        .then((pages) =>
          Array.isArray(pages) && pages.length && pages[0].content?.rendered
            ? parseSettings(pages[0].content.rendered)
            : null
        )
        .catch(() => null);
    }
    cache.then((parsed) => {
      if (!cancelled && parsed && Object.keys(parsed).length) {
        setSettings({ ...DEFAULT_SETTINGS, ...parsed });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return settings;
};
